var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 859,
    height: 859,
    viewBox: "0 0 859 859",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M459.805 3.33829L81.813 381.33C-27.271 490.414 -27.271 667.274 81.813 776.358C190.897 885.441 367.757 885.441 476.84 776.358C476.877 776.321 476.914 776.284 476.951 776.247L854.832 398.366C859.284 393.914 859.284 386.697 854.832 382.245L475.925 3.33829C471.474 -1.11276 464.256 -1.11276 459.805 3.33829Z",
    fill: "#EEF1FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape);
export default __webpack_public_path__ + "static/media/shape.25d76ceec3e9d1ad987509bc91151b67.svg";
export { ForwardRef as ReactComponent };